import {inject, injectable} from 'inversify';

import type {CoreUserProfileUpdateParams} from '../../../../../api/types/core/methods';
import type {UserApiModel} from '../../../../../api/user';
import type {UserOnboardingModel} from '../UserOnboarding.model';

import {DateTimeModelFactory} from '../../../Date/DateTime.factory';
import {UserOnboardingFactory} from '../UserOnboarding.factory';

@injectable()
export class UserOnboardingMapperJrpc {
  constructor(
    @inject(UserOnboardingFactory)
    private readonly factory: UserOnboardingFactory,
    @inject(DateTimeModelFactory)
    private readonly dateTimeFactory: DateTimeModelFactory,
  ) {}

  mapDataToModel(
    apiData: UserOnboardingMapperJrpc.ApiData,
  ): UserOnboardingModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(
    apiData: UserOnboardingMapperJrpc.ApiData,
  ): UserOnboardingModel.Props {
    if (apiData) {
      return {
        answers: apiData.answers,
        finished: apiData.finished
          ? this.dateTimeFactory.createFromDateTimeObject(apiData.finished)
          : null,
        type: apiData.type as UserOnboardingModel.Type,
      };
    }

    return UserOnboardingFactory.EMPTY_PROPS;
  }

  mapModelToDto(model: UserOnboardingModel): UserOnboardingMapperJrpc.Dto {
    return {
      answers: model.answers,
      finished: model.finished?.toISOString() ?? null,
      type: model.type || 'internal',
    };
  }
}

export namespace UserOnboardingMapperJrpc {
  export type ApiData = UserApiModel['onboarding'];

  export type Dto = CoreUserProfileUpdateParams['onboarding'];
}
